/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// components
import { LoaderButton } from '../../../../common/components';

function LeadsFilters({ handleLoadShoppers, loading }) {
  const dispatch = useDispatch();
  const { searchTerm } = useSelector(store => store.shoppers);
  const [ searching, setSearching ] = useState(false);
  const [ clearing, setClearing ] = useState(false);

  function handleChange(e) {
    const { value: val } = e.target;
    dispatch({ type: 'SET_SHOPPERS_KEYS', payload: { searchTerm: val } });
  }

  function handleSearch() {
    setSearching(true);
    handleLoadShoppers({ searchTerm }).finally(() => setSearching(false));
  }

  function handleClear() {
    setClearing(true);
    dispatch({ type: 'SET_SHOPPERS_KEYS', payload: { searchTerm: '' } });
    handleLoadShoppers({ searchTerm: '' }).finally(() => setClearing(false));
  }

  return (
    <div className="row">
      <div className="col-md-4">
        <input
          id="search-term-input"
          placeholder="Search by Name / Lead ID"
          className="form-control"
          value={searchTerm}
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => {
            if (e.keyCode === 13) handleSearch();
          }}
        />
      </div>
      <div className="col-md-5">
        <LoaderButton
          className="btn btn-secondary"
          text="Search"
          loadingText="Searching"
          loading={searching}
          onClick={() => handleSearch()}
        />
        <LoaderButton
          className="btn btn-primary ms-2"
          text="Clear"
          loadingText="Clearing"
          loading={clearing}
          onClick={() => handleClear()}
        />
      </div>
    </div>
  );
}

export default LeadsFilters;
